import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPopularJobRolesList } from "./PopularJobRolesListAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchPopularJobRolesListAsync = createAsyncThunk(
  "PopularJobRolesList/fetch",
  async ({uuid}, { rejectWithValue }) => {
    try {
      const data = await fetchPopularJobRolesList(uuid);

      const resp = data?.response;
      // console.log("response", resp)
      
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PopularJobRolesListSlice = createSlice({
  name: "PopularJobRolesList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPopularJobRolesListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPopularJobRolesListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
        // console.log("data api", action.payload);
        state.error = null;
      })
      .addCase(fetchPopularJobRolesListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectPopularJobRolesList = (state) => state.popularJobRolesList.data;

export default PopularJobRolesListSlice.reducer;
